export default {
  controls: [
    {
      title: 'special.controls.control-panel',
      icon: 'icon-iboard',
      controlPanel: 'iboard'
    }
  ]
}
